import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { cn } from "../../../../util/cn";

// Styled component using MUI v5's `styled`
const SquareBox = styled(Box, {
  shouldForwardProp: (prop) =>
    !["top", "left", "height", "active", "isConfigBox"].includes(
      prop as string
    ),
})<{
  top: number;
  left: number;
  height: number;
  active: boolean;
  isConfigBox?: boolean;
}>(({ theme, top, left, height, active, isConfigBox }) => ({
  position: "absolute",
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  paddingRight: "8px",
  paddingBottom: "2px",
  width: "120px",
  top: `${top}px`,
  left: `${left}px`,
  height: `${height}px`,
  backgroundColor: isConfigBox
    ? theme.palette.grey[400]
    : active
    ? theme.palette.primary.light
    : theme.palette.primary.dark,
}));

interface CP6BoxDoorProps {
  top: number;
  left: number;
  height: number;
  doorNumber: number;
  active: boolean;
  isConfigBox?: boolean;
}

const CP6BoxDoor = (props: CP6BoxDoorProps) => {
  const { top, left, height, doorNumber, active, isConfigBox } = props;

  return (
    <SquareBox
      top={top}
      left={left}
      height={height}
      active={active}
      isConfigBox={isConfigBox}
    >
      {!isConfigBox && (
        <span
          className={cn(
            "font-semibold text-xl leading-8",
            active ?? "text-primary"
          )}
        >
          {doorNumber}
        </span>
      )}
    </SquareBox>
  );
};

export default CP6BoxDoor;
